import { render, staticRenderFns } from "./ChangeRequestOrderItemDialog.vue?vue&type=template&id=3a2ce430"
import script from "./ChangeRequestOrderItemDialog.vue?vue&type=script&lang=js"
export * from "./ChangeRequestOrderItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports